/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from "react";
import {Component } from "react";

import {NavigationConfiguration, NavigationItemConfiguration} from "../../../config/navigation-configuration";
import {UiState} from "../../../core/ui-state";
import SVG from "react-inlinesvg";
import crossIcon from "../../../assets/images/layout/cross.svg";
import {AppState} from "../app-mobx";


export interface MobileNavigationProps {
    config: NavigationConfiguration;
    uiStore: UiState;
    appStore: AppState;
    handleNavigation: (route: string, topicId: string | undefined) => void;
}

export class MobileNavigation extends Component<MobileNavigationProps, any> {
    uiStore: UiState;
    constructor(props: MobileNavigationProps) {
        super(props);
        this.uiStore = this.props.uiStore;
        this.state = {
            search: null
        };
    }
    setSidebarVisible(sidebarVisible: boolean): void {
        this.uiStore.setSidebarVisible(sidebarVisible);
    }
    handleLocalUrl(event: React.MouseEvent, item: NavigationItemConfiguration): void {
        event.preventDefault();
        this.setSidebarVisible(false);
        const route = (event.target as HTMLAnchorElement).pathname;
        this.props.handleNavigation(route, item.topicId);
    }

    handleLogin(event: React.MouseEvent): void {
        const {appStore} = this.props;
        const {authentication} = appStore;
        if (appStore.loggedIn) {
            authentication.logout();
        } else {
            authentication.login().then((credential: __esri.Credential) => {
                appStore.setLoggedIn(true, credential);
            }).catch(() => {
                appStore.setLoggedIn(false);
            });
        }
    }

    render(): React.ReactElement | null {
        const {config, appStore} = this.props;
        const naviItems: React.ReactElement[] = [];
        config.items.forEach((element: NavigationItemConfiguration, index) => {
            naviItems.push(<li className="navigation__list-item" key={"mobile-navigation-" + index}>
                <a href={element.href} target={element.target} onClick={(event: React.MouseEvent<HTMLAnchorElement>) =>
                    this.handleLocalUrl(event, element)}>{element.title}</a>
            </li>);
        });

        // login/logout
        naviItems.push(
            <li className={"navigation__list-item"} key={"mobile-navigation-" + (naviItems.length + 1)}>
                <a href={"/login"} onClick={(event: React.MouseEvent<HTMLAnchorElement>) =>
                    this.handleLogin(event)}>
                    {appStore.loggedIn ? "Abmelden" : "Anmelden"}
                </a>
            </li>
        );

        return(
            <div id="mobileNav" className="mobilenavigation">
                <div className="mobilenavigation__header">
                    <button className="no-focusborder offside-button mobilenavigation__close-button" type="button"
                        onClick={() => this.setSidebarVisible(false)}><span
                            className="sprite sprite--cross">
                            <SVG src={crossIcon} />

                        </span></button>
                </div>
                <div className="mobilenavigation__inner">
                    <div className="navigation home">
                        <ul className="navigation__list">
                            {naviItems}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}
